import {
  Button,
  DatePicker,
  Form,
  InputNumber,
  Input,
  Modal,
  Radio,
  Select,
  Switch,
  Tooltip,
  notification,
  Space
} from 'antd';
import { QuestionCircleOutlined } from '@ant-design/icons';
import React, { useEffect, useState } from 'react';
import moment from 'moment';
import { useParams, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { preRequisitesLayout } from '../../utils/constants/formLayout';
import PreRequisitesSwitch from './PreRequisitesSwitch';
import useQuotesContext from './QuotesContext';
import { formatValue } from '../../utils/formatValue';
import useAuthContext from '../../contexts/AuthContext';
import ComparisonTable from './ComparisonTable';
import {
  assoSwitchesDefaultRc,
  assoSwitchesDefaultLocal
} from './assoSwitchDefault';
import useErrorMessage from '../../utils/ErrorMessage';
import CGUp25 from '../../assets/CGUMRP.pdf';

import GoogleMapsIcon from '../../assets/images/icons/Google_Maps_icon.png';

const { Option } = Select;
const dateFormat = 'DD/MM/YYYY';

const useASSOFields = ({
  form,
  terminationNonPayment,
  setTerminationNonPayment
}) => {
  const { t } = useTranslation();
  const {
    exemptions,
    formValues,
    setFormValues,
    codesNaf,
    estimatedCost,
    catNat,
    enums,
    postalCode,
    setPostalCode,
    activitiesAsso,
    errorGetCities,
    setErrorGetCities
  } = useQuotesContext();
  const { dispatchAPI } = useAuthContext();
  const [isLoading, setIsLoading] = useState(false);
  const { message } = useErrorMessage();
  const [isCityLoading, setIsCityLoading] = useState(false);
  const [addressSuggestion, setAddressSuggestion] = useState([]);
  const [cities, setCities] = useState([]);
  const [visible, setVisible] = useState(false);
  const location = useLocation();
  const params = new URLSearchParams(location.search);
  const { subPath: type } = useParams();
  const assoType = params.get('assoT');
  const activities = form.getFieldValue('activities');
  const isAmendment = window.location.href.search('amendment');
  const [checkedVal, setCheckedVal] = useState('');

  const chosenPckg = formValues?.PACKAGE_1;
  const unauthorized_activities = t(
    'contracts.form.unauthorized_activities'
  ).split('.');
  const defaultPackageValues = {
    PACKAGE_1: {
      fire_explosion_attack_climatic_event: assoType !== 'rc' ? 10000 : 0,
      theft_vandalism: assoType !== 'rc' ? 5000 : 0,
      water_damage: assoType !== 'rc' ? 5000 : 0,
      broken_windows: assoType !== 'rc' ? 2000 : 0,
      electric_damage: assoType !== 'rc' ? 2000 : 0,
      ...(assoType !== 'rc'
        ? { ...assoSwitchesDefaultLocal }
        : { ...assoSwitchesDefaultRc })
    }
  };

  const openNotificationWithIcon = (notificationType, value) => {
    if (value) {
      notification[notificationType]({
        message: 'Notification de dérogation',
        description: t('help.activities'),
        duration: 7,
        key: 'oneTime'
      });
    } else {
      notification[notificationType]({
        message: t('contracts.form.contribution_adjustment_message'),
        key: 'oneTime'
      });
    }
  };
  useEffect(() => {
    if (exemptions.includes(checkedVal)) {
      openNotificationWithIcon('warning', 'value');
    }
  }, [exemptions.length]);
  useEffect(() => {
    form.setFieldsValue(defaultPackageValues);
    setFormValues({
      ...formValues,
      ...defaultPackageValues,
      ...chosenPckg
    });
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    if (formValues && formValues.company_been_insured) {
      if (formValues && formValues.termination_by_company) {
        if (
          formValues.termination_reason_by_company ===
            'TERMINATION_NO_PAYMENT' &&
          type === 'association'
        ) {
          form.setFieldsValue({
            fraction_type: 'YEARLY',
            payment_type: 'CARD'
          });
          setFormValues({
            ...formValues,
            fraction_type: 'YEARLY',
            payment_type: 'CARD'
          });
          setTerminationNonPayment(true);
        } else {
          setTerminationNonPayment(false);
        }
      } else {
        setTerminationNonPayment(false);
      }
    } else {
      setTerminationNonPayment(false);
    }

    // eslint-disable-next-line
  }, [
    formValues?.company_been_insured,
    formValues?.termination_reason_by_company,
    formValues?.termination_by_company
  ]);
  useEffect(() => {
    if (estimatedCost && estimatedCost.cat_nat_risk) {
      form.setFieldsValue({ cat_nat_risk: estimatedCost.cat_nat_risk });
      setFormValues({
        ...formValues,
        cat_nat_risk: estimatedCost.cat_nat_risk,
        ...chosenPckg
      });
    }
    // eslint-disable-next-line
  }, [catNat]);

  const getCommuneCode = (value, key) => {
    try {
      setIsLoading(true);
      if (value) {
        const communCode = cities.find(
          (city) => city.nom === value.split(' (')[0]
        ).code;
        form.setFieldsValue({
          sites: form.getFieldValue('sites').map((values, index) =>
            index === key
              ? {
                  ...values,
                  address: {
                    ...values.address,
                    commune_code: communCode
                  }
                }
              : { ...values }
          )
        });
      }
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    setIsLoading(false);
  };

  const setAddress = (key, data, commune_code) =>
    form.getFieldValue('sites').map((values, index) =>
      index === key
        ? {
            ...values,
            address: {
              number: data.result.address_components[0].long_name,
              street: data.result.address_components[1].long_name,
              administrative_area_level_2:
                data.result.address_components[3].long_name,
              postal_code: data.result.address_components[6].long_name,
              city: data.result.address_components[2].long_name,
              formatted_address: data.result.formatted_address,
              lat: data.result.geometry.location.lat,
              lng: data.result.geometry.location.lng,
              commune_code,
              address_autocomplete: ''
            }
          }
        : { ...values }
    );
  const getCity = async (postal_code, placeIdData, key) => {
    setIsCityLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/insee/cities/${postal_code}`
      });
      const tmpData = data
        .map((city) => {
          if (city.codesPostaux.length > 1) {
            return city.codesPostaux.map((codePostal) => ({
              nom: city.nom.toUpperCase(),
              codePostal,
              code: city.code
            }));
          }
          return {
            nom: city.nom.toUpperCase(),
            codePostal: city.codesPostaux[0],
            code: city.code
          };
        })
        .flat();
      setCities(tmpData);
      setIsCityLoading(false);
      setErrorGetCities(false);
      let commune_code = '';
      if (placeIdData) {
        if (tmpData) {
          commune_code = tmpData.find(
            (city) =>
              placeIdData.result.address_components[2].long_name.toUpperCase() ===
              city.nom
          ).code;
        }
        form.setFieldsValue({
          sites: setAddress(key, placeIdData, commune_code)
        });
        setFormValues({
          ...formValues,
          sites: setAddress(key, placeIdData, commune_code),
          ...chosenPckg
        });
      }
      return tmpData;
    } catch (e) {
      if (e.response) {
        message(e.response.status);
      }
      setIsCityLoading(false);
      const isNotFoundError = e.response?.status === 404;
      setErrorGetCities(!isNotFoundError);
      return [];
    }
  };

  const handlePostalCodeChange = async (event, key) => {
    const { value } = event.target;

    if (value && value.length >= 2) {
      setPostalCode(value);
      const tmpCities = await getCity(value.slice(0, 2));

      if (tmpCities) {
        const filteredCities = tmpCities.filter((city) => {
          let isMatching = false;

          if (city.codePostal.startsWith(value)) {
            isMatching = true;
          }

          return isMatching;
        });

        if (filteredCities.length === 1) {
          form.setFieldsValue({
            sites: form.getFieldValue('sites').map((values, index) =>
              index === key
                ? {
                    ...values,
                    address: {
                      ...values.address,
                      city: `${filteredCities[0].nom} (${filteredCities[0].codePostal})`
                    }
                  }
                : { ...values }
            )
          });
        }
      } else {
        form.setFieldsValue({
          sites: form.getFieldValue('sites').map((values, index) =>
            index === key
              ? {
                  ...values,
                  address: {
                    ...values.address,
                    city: undefined
                  }
                }
              : { ...values }
          )
        });
      }
    }
  };

  const getAddressAutocomplete = async (address_autocomplete) => {
    if (address_autocomplete) {
      setIsLoading(true);
      try {
        const { data } = await dispatchAPI('GET', {
          url: `/places/${address_autocomplete}`
        });
        setAddressSuggestion(data?.predictions);
      } catch (e) {
        if (e.response) message(e.response.status);
      }
      setIsLoading(false);
    }
  };

  const getAddressPlaceId = async (placeId, key) => {
    setIsLoading(true);
    try {
      const { data } = await dispatchAPI('GET', {
        url: `/places/placeid/${placeId}`
      });
      if (data) {
        await getCity(
          data.result.address_components[6].long_name.substring(0, 2),
          data,
          key
        );
      }
    } catch (e) {
      if (e.response) message(e.response.status);
    }
    setIsLoading(false);
  };

  const assoFields = [
    {
      name: ['activities'],
      label: 'activities_asso',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <Select
          className="activities-select"
          mode="multiple"
          style={{ width: 400 }}
          options={activitiesAsso
            .filter((code) => code?.display?.ASSOCIATION)
            .map(({ name }) => ({
              value: `${name}`,
              label: `${name} `
            }))}
          filterOption={(input, option) =>
            formatValue(option.label).indexOf(formatValue(input)) > -1
          }
          onChange={(value) =>
            setFormValues({
              ...formValues,
              activities: value
            })
          }
        />
      ),
      help: exemptions.includes('activities')
        ? t('help.exemptions_activities_asso')
        : null,
      step: 0
    },
    {
      label: 'budget',
      name: ['turnover'],
      tooltip: true,
      rules: [
        { required: true },
        {
          validator: (_, value) =>
            formValues && value > 0 ? Promise.resolve() : Promise.reject()
        }
      ],
      input: (
        <InputNumber
          min={0}
          style={{ width: 120 }}
          onChange={(value) =>
            setFormValues({
              ...formValues,
              turnover: value
            })
          }
        />
      ),
      help: exemptions.includes('turnover') ? t('help.exemptions') : null,
      step: 0
    },
    {
      name: ['representatives_number'],
      label: 'representatives_number',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <InputNumber
          min={0}
          onChange={(value) =>
            setFormValues({
              ...formValues,
              representatives_number: value
            })
          }
        />
      ),
      help: exemptions.includes('representatives_number')
        ? t('help.exemptions')
        : null,
      step: 0
    },
    {
      name: ['employees_number'],
      label: 'employees_number_asso',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <InputNumber
          min={0}
          onChange={(value) =>
            setFormValues({
              ...formValues,
              employees_number: value
            })
          }
        />
      ),
      help: exemptions.includes('employees_number')
        ? t('help.exemptions')
        : null,
      step: 0
    },
    {
      name: ['total_members'],
      label: 'total_members',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <InputNumber
          min={0}
          onChange={(value) =>
            setFormValues({
              ...formValues,
              total_members: value
            })
          }
        />
      ),
      help: exemptions.includes('total_members') ? t('help.exemptions') : null,
      step: 0
    },
    {
      name: ['yearly_events'],
      label: 'yearly_events',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <Radio.Group
          buttonStyle="solid"
          value={formValues?.yearly_events}
          onChange={(e) => {
            const value = e.target.value;
            const noYealyEvents = value === 0 || value === '0';
            setFormValues({
              ...formValues,
              yearly_events: value,
              ...(noYealyEvents
                ? { participants_per_event: 'MAXIMUM_200' }
                : {})
            });
            if (noYealyEvents)
              form.setFieldsValue({ participants_per_event: 'MAXIMUM_200' });
          }}
        >
          <Radio.Button value="0">
            {t('contracts.form.association.yearly_events.0')}
          </Radio.Button>

          <Radio.Button value="MAXIMUM_5">
            {t('contracts.form.association.yearly_events.MAXIMUM_5')}
          </Radio.Button>

          <Radio.Button value="MAXIMUM_12">
            {t('contracts.form.association.yearly_events.MAXIMUM_12')}
          </Radio.Button>

          <Radio.Button value="MORE_THAN_12">
            {t('contracts.form.association.yearly_events.MORE_THAN_12')}
          </Radio.Button>
        </Radio.Group>
      ),
      help: exemptions.includes('yearly_events') ? t('help.exemptions') : null,
      step: 0
    },
    {
      step: 0,
      name: ['participants_per_event'],
      tooltip: false,
      rules: [{ required: true }],
      hidden: formValues?.yearly_events === '0',
      input: (
        <Radio.Group
          buttonStyle="solid"
          value={formValues?.participants_per_event}
          onChange={(e) =>
            setFormValues({
              ...formValues,
              participants_per_event: e.target.value
            })
          }
        >
          <Radio.Button value="MAXIMUM_200">
            {t('contracts.form.association.participants_per_event.MAXIMUM_200')}
          </Radio.Button>

          <Radio.Button value="MAXIMUM_500">
            {t('contracts.form.association.participants_per_event.MAXIMUM_500')}
          </Radio.Button>

          <Radio.Button value="MAXIMUM_700">
            {t('contracts.form.association.participants_per_event.MAXIMUM_700')}
          </Radio.Button>

          <Radio.Button value="MORE_THAN_700">
            {t(
              'contracts.form.association.participants_per_event.MORE_THAN_700'
            )}
          </Radio.Button>
        </Radio.Group>
      )
    },
    {
      name: ['number_claims'],
      label: 'number_claims',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <InputNumber
          min={0}
          onChange={(value) =>
            setFormValues({
              ...formValues,
              number_claims: value
            })
          }
        />
      ),
      help: exemptions.includes('number_claims') ? t('help.exemptions') : null,
      step: 0
    },
    ...(formValues && formValues.number_claims >= 1
      ? [
          {
            name: ['claims'],
            noLabel: false,
            step: 0,
            help: exemptions.includes(`claim_amount`)
              ? t('help.exemptions')
              : null,
            input: (
              <Form.List name="claims">
                {(fields) => (
                  <div>
                    {fields.map((field) => (
                      <Space
                        key={field.key}
                        style={{ display: 'flex', marginBottom: 8 }}
                        align="baseline"
                      >
                        <Form.Item
                          noStyle
                          {...field}
                          name={[field.name, 'claim_date']}
                          key={[field.fieldKey, 'claim_date']}
                          rules={[
                            {
                              required: true,
                              message: 'Date du sinistre manquant'
                            }
                          ]}
                        >
                          <DatePicker
                            format={dateFormat}
                            style={{ minWidth: 200 }}
                            disabledDate={(current) => {
                              return current >= moment();
                            }}
                          />
                        </Form.Item>
                        <Form.Item
                          noStyle
                          {...field}
                          name={[field.name, 'claim_type']}
                          key={[field.fieldKey, 'claim_type']}
                          rules={[
                            {
                              required: true,
                              message: 'Type du sinistre manquant'
                            }
                          ]}
                        >
                          <Input
                            style={{ width: '200px' }}
                            placeholder="Type de sinistre"
                          />
                        </Form.Item>
                        <Form.Item
                          noStyle
                          {...field}
                          name={[field.name, 'claim_amount']}
                          key={[field.fieldKey, 'claim_amount']}
                          rules={[
                            {
                              required: true,
                              message: 'Montant du sinistre manquant'
                            }
                          ]}
                        >
                          <InputNumber
                            min={0}
                            style={{ width: '200px' }}
                            formatter={(value) => value && `${value}€`}
                            parser={(value) => value.replace('€', '')}
                            placeholder="Montant du sinistre"
                          />
                        </Form.Item>
                      </Space>
                    ))}
                  </div>
                )}
              </Form.List>
            )
          }
        ]
      : []),
    {
      label: ['association_been_insured'],
      name: ['company_been_insured'],
      rules: [{ required: true }],
      input: (
        <PreRequisitesSwitch
          onChange={(value) =>
            setFormValues({
              ...formValues,
              company_been_insured: value
            })
          }
        />
      ),
      valuePropName: 'checked',
      step: 0
    },
    ...(formValues && formValues.company_been_insured
      ? [
          {
            name: ['last_company_name'],
            input: <Input style={{ width: 500 }} />,
            rules: [{ required: true }],
            step: 0
          },
          {
            name: ['last_contract_number'],
            input: <Input style={{ width: 500 }} />,
            step: 0
          },
          {
            name: ['last_termination_date'],
            input: <DatePicker format={dateFormat} style={{ minWidth: 200 }} />,
            step: 0
          },
          {
            name: ['termination_by_company'],
            label: 'termination_by_company_asso',
            rules: [{ required: true }],
            input: <PreRequisitesSwitch />,
            valuePropName: 'checked',
            tooltip: true,
            step: 0
          },
          ...(formValues && formValues.termination_by_company
            ? [
                {
                  name: ['termination_reason_by_company'],
                  rules: [
                    { required: true },
                    {
                      validator: () =>
                        formValues.number_claims >= 1
                          ? Promise.reject(
                              new Error(
                                'Ce champs est L’offre ASSURMAX pour les associations résiliées non paiement est réservée aux associations sans aucun sinistre dans les 60 derniers mois  requis.'
                              )
                            )
                          : Promise.resolve()
                    }
                  ],
                  input: (
                    <Select style={{ width: 220 }}>
                      {enums?.termination_reason_by_company &&
                        enums.termination_reason_by_company.map((e) => (
                          <Option value={e} key={e}>
                            {t(`contracts.form.${e}`)}
                            <Tooltip
                              title={t(`contracts.form.tooltip.${e}`)}
                              overlayInnerStyle={{ width: 500 }}
                            >
                              <QuestionCircleOutlined
                                style={{ float: 'right' }}
                              />
                            </Tooltip>
                          </Option>
                        ))}
                    </Select>
                  ),
                  // eslint-disable-next-line no-nested-ternary
                  help: exemptions.includes('termination_by_company')
                    ? t('help.exemptions')
                    : formValues.termination_reason_by_company ===
                        'TERMINATION_NO_PAYMENT'
                      ? t('help.terminated_non_payment')
                      : null,
                  step: 0
                }
              ]
            : []),
          ...(formValues &&
          formValues.termination_reason_by_company === 'TERMINATION_NO_PAYMENT'
            ? [
                {
                  name: ['confirm_claims'],
                  label: 'confirm_claims',
                  rules: [{ required: true }],
                  input: <PreRequisitesSwitch />,
                  valuePropName: 'checked',
                  tooltip: true,
                  help: exemptions.includes('confirm_claims')
                    ? t('help.exemptions')
                    : null,
                  step: 0
                }
              ]
            : []),
          ...(formValues &&
          formValues.termination_reason_by_company === 'termination_other'
            ? [
                {
                  name: ['termination_reason_by_company_custom'],
                  rules: [{ required: true }],
                  input: (
                    <Input
                      value={formValues.termination_reason_by_company_custom}
                      onChange={(value) =>
                        setFormValues({
                          ...formValues,
                          termination_reason_by_company_custom: value,
                          ...chosenPckg
                        })
                      }
                      style={{ width: 250 }}
                    />
                  ),
                  step: 0
                }
              ]
            : []),
          ...(formValues && formValues.termination_by_company
            ? [
                {
                  name: ['termination_date_by_company'],
                  input: (
                    <DatePicker
                      format={dateFormat}
                      style={{ minWidth: 200 }}
                      disabledDate={(current) => current > moment()}
                    />
                  ),
                  step: 0
                }
              ]
            : [])
        ]
      : []),

    {
      name: ['local'],
      hidden: true,
      input: (
        <Switch
          checkedChildren={t('quotes.form.switch.yes')}
          unCheckedChildren={t('quotes.form.switch.no')}
          checked={assoType === 'localRc'}
          disabled
        />
      ),

      step: 0
    },
    ...(assoType === 'localRc'
      ? [
          {
            name: ['sites'],
            noLabel: true,
            help: exemptions.includes('number_sites')
              ? t('help.exemptions')
              : null,
            noStyle: true,
            input: (
              <Form.List
                name="sites"
                initialValue={[
                  { surface_area: 0, tenant_status: 'WITHOUT_CLAUSE' }
                ]}
              >
                {(fields, { remove }) => (
                  <>
                    {fields.map((field) => (
                      <div key={field.name}>
                        <Form.Item
                          {...field}
                          key={[field.name, 'address', 'address_autocomplete']}
                          name={[field.name, 'address', 'address_autocomplete']}
                          label={t(
                            'contracts.form.address.address_autocomplete'
                          )}
                          hasFeedback={isLoading}
                          {...(isLoading
                            ? { validateStatus: 'validating' }
                            : {})}
                        >
                          <Select
                            filterOption={false}
                            showSearch
                            showArrow={false}
                            notFoundContent={null}
                            onSearch={getAddressAutocomplete}
                            onSelect={async (selected) => {
                              const placeId = selected.split('#')[0];
                              await getAddressPlaceId(placeId, field.name);
                            }}
                            options={
                              addressSuggestion &&
                              addressSuggestion.map((predictions) => ({
                                label: predictions.description,
                                value: `${predictions.place_id}#${predictions.description}`
                              }))
                            }
                            autoComplete="anyrandomstring"
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'address', 'number']}
                          key={[field.name, 'address', 'number']}
                          label={t('contracts.form.address.number')}
                          rules={[{ required: true }]}
                        >
                          <InputNumber />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'address', 'street']}
                          key={[field.name, 'address', 'street']}
                          label={t('contracts.form.address.street')}
                          rules={[{ required: true }]}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'address', 'additional']}
                          key={[field.name, 'address', 'additional']}
                          label={t('contracts.form.address.additional')}
                        >
                          <Input />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'address', 'postal_code']}
                          key={[field.name, 'address', 'postal_code']}
                          label={t('contracts.form.address.postal_code')}
                          rules={[
                            () => ({
                              validator(_, value) {
                                let blockedPostCode = false;
                                const selectedActivities = (
                                  activities || []
                                ).map((a) => a.split(' - ')[0]);
                                selectedActivities.forEach((activityName) => {
                                  const activity = codesNaf.find(
                                    (act) => act.name === activityName
                                  );
                                  if (
                                    activity?.excluded_postcode &&
                                    activity?.excluded_postcode.length
                                  ) {
                                    activity.excluded_postcode.forEach(
                                      (postcode) => {
                                        if (value.startsWith(postcode))
                                          blockedPostCode = true;
                                      }
                                    );
                                  }
                                });
                                if (!value || !blockedPostCode)
                                  return Promise.resolve();
                                return Promise.reject(
                                  new Error(
                                    `Ce code postal n'est pas autorisé pour ${
                                      activities.length === 1
                                        ? "l'activité sélectionnée"
                                        : 'les activités sélectionnées'
                                    }`
                                  )
                                );
                              }
                            }),
                            { required: true }
                          ]}
                          help={
                            exemptions.includes('postcode')
                              ? t('help.exemptions')
                              : null
                          }
                        >
                          <Input
                            style={{ width: '90px' }}
                            onChange={handlePostalCodeChange}
                            autoComplete="off"
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'address', 'city']}
                          key={[field.name, 'address', 'city']}
                          label={t('contracts.form.address.city')}
                          rules={[{ required: true }]}
                          hasFeedback={isCityLoading}
                          {...(isCityLoading
                            ? { validateStatus: 'validating' }
                            : {})}
                        >
                          {!errorGetCities ? (
                            <Select
                              showSearch
                              onSelect={(selected) => {
                                getCommuneCode(selected, field.name);
                              }}
                              options={
                                cities &&
                                cities
                                  .filter((city) => {
                                    let isMatching = false;

                                    if (
                                      city.codePostal.startsWith(postalCode)
                                    ) {
                                      isMatching = true;
                                    }

                                    return isMatching;
                                  })
                                  .map((city) => ({
                                    label: `${city.nom} (${city.codePostal})`,
                                    value: `${city.nom} (${city.codePostal})`
                                  }))
                              }
                            />
                          ) : (
                            <Input />
                          )}
                        </Form.Item>
                        {formValues?.sites && formValues?.sites[0]?.address && (
                          <>
                            <a
                              className="form-map-link mrp-map-link"
                              target="_blank"
                              rel="noopener noreferrer"
                              href={`https://www.google.com/maps/@?api=1&map_action=pano&viewpoint=${
                                formValues?.sites[0].address &&
                                formValues?.sites[0].address.lat
                              }0%2C${
                                formValues?.sites[0].address &&
                                formValues?.sites[0].address.lng
                              }&heading=-45&pitch=38&fov=80`}
                            >
                              {`Visualiser l'immeuble `}
                              <img
                                src={GoogleMapsIcon}
                                alt="icone Google Maps"
                              />
                            </a>
                          </>
                        )}
                        <Form.Item
                          {...field}
                          name={[field.name, 'address', 'commune_code']}
                          key={[field.name, 'address', 'commune_code']}
                          label={t('contracts.form.commune_code')}
                          hidden
                        >
                          <Input disabled style={{ width: '90px' }} />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'surface_area']}
                          rules={[
                            {
                              required: true,
                              message: t('errors.form.REQUIRED')
                            },
                            {
                              validator: (_, value) =>
                                formValues && value > 0
                                  ? Promise.resolve()
                                  : Promise.reject(
                                      new Error('Ce champs est requis.')
                                    )
                            }
                          ]}
                          key={[field.name, 'surface_area']}
                          label={t('contracts.form.surface_area')}
                          tooltip={t(
                            'contracts.form.tooltip.surface_area_asso'
                          )}
                          help={
                            exemptions.includes('sites')
                              ? t('help.exemptions')
                              : null
                          }
                        >
                          <InputNumber
                            min={0}
                            rules={[
                              {
                                required: true,
                                message: t('errors.form.REQUIRED')
                              }
                            ]}
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'resident_status']}
                          key={[field.name, 'resident_status']}
                          label={t('contracts.form.resident_status')}
                          rules={[{ required: true }]}
                          help={
                            exemptions.includes('resident_status')
                              ? t('help.exemptions')
                              : null
                          }
                        >
                          <Radio.Group buttonStyle="solid">
                            <Radio.Button value="TENANT">
                              {t('contracts.form.options.TENANT')}
                            </Radio.Button>
                            <Radio.Button value="OWNER">
                              {t('contracts.form.options.OWNER')}
                            </Radio.Button>
                            <Radio.Button value="RENT_FREE">
                              {t('contracts.form.options.RENT_FREE')}
                            </Radio.Button>
                          </Radio.Group>
                        </Form.Item>
                        {formValues?.sites?.length &&
                          ['TENANT'].includes(
                            formValues?.sites[field.name]?.resident_status
                          ) && (
                            <Form.Item
                              {...field}
                              name={[field.name, 'tenant_status']}
                              key={[field.name, 'tenant_status']}
                              rules={[{ required: true }]}
                              label={t(
                                `contracts.form.tenant_status${
                                  formValues?.sites[field.name]
                                    ?.resident_status === 'RENT_FREE'
                                    ? '_rent_free'
                                    : ''
                                }`
                              )}
                              tooltip={t(
                                'contracts.form.tooltip.tenant_status'
                              )}
                              help={
                                exemptions.includes('tenant_status')
                                  ? t('help.exemptions')
                                  : null
                              }
                            >
                              <Select style={{ width: 420 }}>
                                <Option value="TENANT_AGAINST_OWNER">
                                  {t(
                                    'contracts.form.options.TENANT_AGAINST_OWNER'
                                  )}
                                </Option>
                                <Option value="OWNER_AGAINST_TENANT">
                                  {t(
                                    'contracts.form.options.OWNER_AGAINST_TENANT'
                                  )}
                                </Option>
                                <Option value="OWNER_ACTING_TENANT">
                                  {t(
                                    'contracts.form.options.OWNER_ACTING_TENANT'
                                  )}
                                </Option>
                                <Option value="NO_AGAINST">
                                  {t('contracts.form.options.NO_AGAINST')}
                                </Option>
                                <Option value="WITHOUT_CLAUSE">
                                  {t('contracts.form.options.WITHOUT_CLAUSE')}
                                </Option>
                              </Select>
                            </Form.Item>
                          )}
                        <Form.Item
                          {...field}
                          name={[field.name, 'isolated_site']}
                          key={[field.name, 'isolated_site']}
                          label={t('contracts.form.isolated_site')}
                          tooltip={t('contracts.form.tooltip.isolated_site')}
                          valuePropName="checked"
                          help={
                            exemptions.includes('isolated_site')
                              ? t('help.exemptions')
                              : null
                          }
                        >
                          <Switch
                            checkedChildren={t('quotes.form.switch.yes')}
                            unCheckedChildren={t('quotes.form.switch.no')}
                          />
                        </Form.Item>
                        <Form.Item
                          {...field}
                          name={[field.name, 'protection_level']}
                          key={[field.name, 'protection_level']}
                          hidden
                        >
                          <InputNumber />
                        </Form.Item>
                        <Form.Item>
                          {`${t('contracts.form.protection_level')} `}
                          <strong>
                            {formValues?.sites?.[field.name]?.protection_level}
                          </strong>
                        </Form.Item>
                        <Form.Item name="level_protection_modal">
                          <Button type="link" onClick={() => setVisible(true)}>
                            {t('contracts.form.modal_tab')}
                          </Button>
                          <Modal
                            title={t('contracts.form.modal_title')}
                            open={visible}
                            onCancel={() => setVisible(false)}
                            footer={null}
                            width={1200}
                          >
                            <iframe
                              height="900"
                              width="100%"
                              title="Niveau de protection"
                              src={CGUp25}
                            />
                          </Modal>
                        </Form.Item>
                        {formValues?.sites?.length &&
                          formValues?.sites?.length > 1 && (
                            <Form.Item>
                              <Button
                                type="link"
                                danger
                                onClick={() => {
                                  remove(field.name);
                                }}
                              >
                                {t('buttons.removeSite')}
                              </Button>
                            </Form.Item>
                          )}
                      </div>
                    ))}
                  </>
                )}
              </Form.List>
            ),
            step: 0
          }
        ]
      : []),
    {
      name: ['deductible_amount'],
      label: 'deductible_amount',
      tooltip: true,
      rules: [{ required: true }],
      input: (
        <Radio.Group
          buttonStyle="solid"
          onChange={(change) =>
            setFormValues({
              ...formValues,
              deductible_amount: change.target.value
            })
          }
        >
          <Radio.Button value={1000}>1 000€</Radio.Button>
          <Radio.Button value={750}>750€</Radio.Button>
          {formValues && formValues.number_claims < 1 && (
            <>
              <Radio.Button value={500}>500€</Radio.Button>
              <Radio.Button value={250}>250€</Radio.Button>
              <Radio.Button value={0}>0€</Radio.Button>
            </>
          )}
        </Radio.Group>
      ),
      help: exemptions.includes('deductible_amount')
        ? t('help.exemptions')
        : null,
      step: assoType === 'localRc' ? 1 : 0
    },
    {
      step: assoType === 'localRc' ? 1 : 0,
      name: ['comparison'],
      noStyle: true,
      noLabel: true,
      layout: {
        labelCol: { span: 0 },
        wrapperCol: { xs: 24, sm: 24, md: 24, lg: 24, xl: 24 }
      },
      input: (
        <ComparisonTable
          form={form}
          fields={[
            ...(formValues?.local
              ? [
                  {
                    name: ['fire_explosion_attack_climatic_event'],
                    type: 'number'
                  },
                  { name: ['water_damage'], type: 'number' },
                  { name: ['theft_vandalism'], type: 'number' },
                  { name: ['broken_windows'], type: 'number' },
                  { name: ['electric_damage'], type: 'select' }
                ]
              : []),
            {
              name: ['legal_protection'],
              type: 'fixed'
            },
            { name: ['local_insurance'], type: 'fixed' },
            ...(formValues?.local
              ? [
                  {
                    name: ['light_inflatable_structure'],
                    type: 'switch'
                  }
                ]
              : []),
            {
              name: ['civil_responsibility_asso'],
              type: `${formValues?.local ? 'switch' : 'fixed'}`
            },
            // eslint-disable-next-line no-nested-ternary
            ...(formValues?.local
              ? formValues?.civil_responsibility_asso
                ? [{ name: ['social_mandate_responsibility'], type: 'switch' }]
                : []
              : [{ name: ['social_mandate_responsibility'], type: 'switch' }]),
            {
              name: ['extended_legal_protection'],
              type: 'switch'
            },
            { name: ['classic_accident_insurance'], type: 'switch' },
            ...(formValues?.classic_accident_insurance
              ? [
                  {
                    name: ['reinforced_accident_insurance'],
                    type: 'switch'
                  }
                ]
              : [])
          ]}
          columns={[{ title: 'PACKAGE_1' }]}
          assoType={assoType}
        />
      )
    },
    {
      name: ['fraction_type'],
      label: ['fraction_type'],
      rules: [{ required: true }],
      tooltip: true,
      input: (
        <Radio.Group
          buttonStyle="solid"
          onChange={(change) =>
            setFormValues({
              ...formValues,
              fraction_type: change.target.value
            })
          }
          disabled={isAmendment !== -1}
        >
          <Radio.Button value="MONTHLY" disabled={terminationNonPayment}>
            {t('contracts.form.options.MONTHLY')}
          </Radio.Button>
          <Radio.Button value="YEARLY">
            {t('contracts.form.options.YEARLY')}
          </Radio.Button>
        </Radio.Group>
      ),
      step: assoType === 'localRc' ? 1 : 0
    },
    {
      name: ['litigation_responsibility'],
      step: assoType === 'rc' ? 1 : 2
    },
    {
      name: ['annual_budget'],
      step: assoType === 'rc' ? 1 : 2
    },
    {
      name: ['political_activity'],
      step: assoType === 'rc' ? 1 : 2
    },
    ...(formValues?.termination_reason_by_company === 'TERMINATION_NO_PAYMENT'
      ? [
          {
            name: ['no_claims'],
            step: assoType === 'rc' ? 1 : 2
          }
        ]
      : [
          {
            name: ['max_claims'],
            step: assoType === 'rc' ? 1 : 2
          }
        ]),
    {
      name: ['blocked_activities'],
      step: assoType === 'rc' ? 1 : 2,
      blocked_activities: true,
      label: (
        <>
          <div style={{ display: 'flex', flexDirection: 'column' }}>
            {' '}
            {t('contracts.form.blocked_activities')}
            <ul style={{ listStyleType: 'none' }}>
              {unauthorized_activities.map((value) => (
                <li>{value}</li>
              ))}
            </ul>
          </div>
        </>
      )
    },
    ...(assoType === 'localRc'
      ? [
          {
            name: ['is_a_palace'],
            step: 2
          },
          {
            name: ['monument'],
            step: 2
          },
          {
            name: ['closed_more_60_days'],
            step: 2
          },
          {
            name: ['embassy_bowling_disco'],
            step: 2
          },
          {
            name: ['industry_less_10m'],
            step: 2
          },
          {
            name: ['renovation'],
            step: 2
          },
          {
            name: ['had_waived_certain_remedies_in_its_lease'],
            step: 2
          },
          {
            name: ['disaffected'],
            step: 2
          },
          {
            name: ['zone_ind_com_art'],
            step: 2
          },
          {
            name: ['metropolitan_france'],
            step: 2
          },
          {
            name: ['built_covered_hard_materials'],
            step: 2
          },
          {
            name: ['take_care_building'],
            step: 2
          },
          {
            name: ['extinguisher_conformed'],
            step: 2
          },
          {
            name: ['close_help'],
            step: 2
          },
          {
            name: ['altitude_location'],
            step: 2
          }
        ]
      : [])
  ];

  return {
    assoFields: assoFields.map((f) => {
      if (assoType === 'localRc' && f.step === 2)
        return {
          ...f,
          input: (
            <PreRequisitesSwitch
              onChange={(val) => {
                setFormValues({
                  ...formValues,
                  [f.name[0]]: val
                });
                setCheckedVal(f.name[0]);
              }}
            />
          ),
          labelAlign: 'left',

          withDivider: false,
          valuePropName: 'checked',
          layout: preRequisitesLayout
        };
      if (assoType === 'rc' && f.step === 1)
        return {
          ...f,
          input: (
            <PreRequisitesSwitch
              onChange={(val) => {
                setFormValues({
                  ...formValues,
                  [f.name[0]]: val
                });
                setCheckedVal(f.name[0]);
              }}
            />
          ),
          labelAlign: 'left',
          valuePropName: 'checked',
          withDivider: true,
          layout: preRequisitesLayout
        };

      return f;
    })
  };
};

export default useASSOFields;
